<section class="content apc standard-components c5-bg content-container-div" id="pos_1404"
  style="background-color: #2196f3;">
  <div style="max-width: 820px; margin: auto; padding: 0px 10px">
    <p class="heading os-animation fadeInUp animated">Projects</p>
    <div class="text c5-text os-animation fadeInUp animated" data-os-animation="fadeInUp" data-os-animation-delay="0.2s"
      style="animation-delay: 0.2s">
      <p>Select your project or create a new one to add your data</p>
    </div>

    <div style="margin: 10px 0">
      <div style="display: flex; justify-content: space-between; flex-wrap: wrap; gap: 10px;">
        <div>
          <button nzGhost nz-button [disabled]="!this.selectedProject" (click)="goToProjectPage()">
            Project Page
          </button>
        </div>

        <div style="display: flex; gap: 20px">
          @if (this.isStaff) {
            <button nz-button nzGhost (click)="goToCostAnalysis()">
              Cost Analysis
            </button>
          }
        </div>
      </div>
    </div>

    <div style="display: flex; gap: 0px 10px; margin: 10px 0; flex-wrap: wrap;">
      <!-- <div> -->
      <nz-input-group style="flex: 1 1 300px">
        <label style="color: white; font-size: 20px; margin: 0">
          Field
        </label>
        <nz-select style="width: 100%; color: white" nzShowSearch nzAllowClear [nzFilterOption]="searchFn"
          [(ngModel)]="selectedField" (ngModelChange)="onFieldSelected()">
          <nz-option nzLabel="No Field" nzValue=""></nz-option>
          @for (field of fields | async; track field) {
            <nz-option [nzValue]="field" [nzLabel]="field.name">
              {{ field.name }}
            </nz-option>
          }
        </nz-select>
      </nz-input-group>

      <nz-input-group style="flex: 1 1 300px">
        <label style="color: white; font-size: 20px; margin: 0">
          Project
        </label>
        <nz-select style="width: 100%; color: white" nzShowSearch [nzFilterOption]="searchFn"
          [(ngModel)]="selectedProject" (ngModelChange)="getProjectJobs()">
          @for (project of filteredProjects; track project) {
            <nz-option [nzValue]="project" [nzLabel]="project.name">
              {{ project.name }}
            </nz-option>
          }
        </nz-select>
      </nz-input-group>

    <!-- </div> -->

    <nz-input-group style="max-width: 800px; flex-grow: 1;">
      <label style="color: white; font-size: 20px; margin: 0"> Job </label>
      <nz-select style="width: 100%; color: white" nzShowSearch [nzDisabled]="!selectedProject"
        [nzFilterOption]="searchFn" [(ngModel)]="selectedJob" (ngModelChange)="onJobSelected($event)">
        @for (job of projectJobs; track job) {
          <nz-option [nzValue]="job" [nzLabel]="job.name">
            {{ job.name }}
          </nz-option>
        }
      </nz-select>
    </nz-input-group>
  </div>

  <div style="color: white; white-space: pre-wrap">
    {{ projectDescriptipon }}
  </div>

  <button nz-button nzGhost nzBlock nzType="dashed" (click)="projectModalVisible = true" style="margin: 10px 0">
    <span nz-icon nzType="plus" nzTheme="outline"></span> Create New Project
  </button>
</div>
</section>

<app-fields-listing></app-fields-listing>

<nz-modal [nzVisible]="projectModalVisible" nzTitle="Create New Project" (nzOnCancel)="projectModalVisible = false"
  (nzOnOk)="createProject()">
  <ng-container *nzModalContent>
    <form nz-form [formGroup]="projectFormGroup" (ngSubmit)="createProject()" class="form-container">
      <nz-form-item>
        <nz-form-label for="name" nzRequired>Project Name</nz-form-label>
        <nz-form-control nzErrorTip="Please input a Project Name">
          <input nz-input type="text" formControlName="name" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label for="Field" nzRequired>Project Field</nz-form-label>
        <nz-form-control nzErrorTip="Please select a Field">
          <!-- <input nz-input type="text" formControlName="name" /> -->
          <nz-select [nzLoading]="isLoading" [nzDisabled]="isLoading" formControlName="field">
            @for (field of fields | async; track field) {
              <nz-option [nzValue]="field.id" [nzLabel]="field.name"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label for="description">Project Description</nz-form-label>
        <nz-form-control>
          <textarea nz-input type="text" formControlName="description"></textarea>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-control
          nzExtra="Projects with Archive Enabled will automatically have their jobs archived after 7 days, unless specfically selected to be kept indefinitely.">
          <label nz-checkbox formControlName="archiveEnabled">Archive Enabled</label>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>
</nz-modal>